// extracted by mini-css-extract-plugin
export default {"google-pay-button":"CG9rTu","googlePayButton":"CG9rTu"};